// import { format } from "date-fns"
// import { utcToZonedTime } from "date-fns-tz"
import { getUserInfo } from "../../js/app/state/appSessionStorage"

// export const convertToUTC = (date: Date): string => {
//   const currentDate = new Date()
//   console.log(currentDate)
//   const utcDate = new Date(Date.UTC(
//     currentDate.getFullYear(),
//     currentDate.getMonth(),
//     currentDate.getDate(),
//     currentDate.getHours(),
//     currentDate.getMinutes(),
//     currentDate.getSeconds()
//   ))
//   // Format the UTC date as a string in the "yyyy-MM-dd HH:mm:ss" format
//   const utcFormat = "yyyy-MM-dd HH:mm:ss" // format for UTC time
//   const utcString = format(utcDate, utcFormat) // send this string to the server
//   console.log(utcString)
//   return utcString
// }

// export const convertToTimezone = (utcString: string): string  => {
// const timeZone = userTimezone ? userTimezone : systemTimezone
//   const date = new Date(utcString)
//   const zonedDate = utcToZonedTime(date, timeZone)
//   const formattedDate = format(zonedDate, "yyyy-MM-dd HH:mm:ss")
//   return formattedDate
// }

import { format, utcToZonedTime } from "date-fns-tz"
import moment from "moment"
import "moment-timezone"

export const convertToUTC = (date: Date): string => {
  const currentDate = new Date(date)
  const utcString = currentDate.toISOString().slice(0, 19).replace("T", " ")
  return utcString
}

// Function to convert current date and time to UTC string
export function getCurrentUTCTimestamp(): string {
  const now = new Date()
  const utcString = now.toISOString().slice(0, 19).replace("T", " ")
  return utcString
}

export const TimeZoneTimeToUtcConverter = (date: any): string => {
  const userTimezone = getUserInfo().timezone
  const systemTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const timeZone = userTimezone || systemTimezone
  const convertedDate = moment.tz(date, timeZone).utc().format("YYYY-MM-DD HH:mm:ss")
  return convertedDate
}

// const currentDate = moment().format("MMMM Do YYYY, h:mm:ss a")

// console.log("This is TimeZone to UtC converter:", TimeZoneTimeToUtcConverter(currentDate))

export const TimeZoneTimeConverter = ( date : Date ) => {
  if(!date) return ""
  const userTimezone = getUserInfo().timezone
  const systemTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const timeZone = userTimezone || systemTimezone
  const convertedDate = moment(date).tz(timeZone).format("YYYY-MM-DD HH:mm:ss")
  return convertedDate
}

// const convertedDate = moment.tz(date, timeZone).utc().format("YYYY-MM-DD HH:mm:ss") this giving error as "Warning: An unhandled error was caught from submitForm() TypeError: moment__WEBPACK_IMPORTED_MODULE_1___default.a.tz is not a function"


// Function to convert UTC timestamp to date and time with timezone
export function convertUTCToTimezone(utcTimestamp: number): string {
  // const utcDate = new Date(utcTimestamp)
  // const zonedDate = utcToZonedTime(utcDate, userTimezone ? userTimezone : systemTimezone)
  // const formattedDate = format(zonedDate, "yyyy-MM-dd HH:mm:ss")
  // return formattedDate
  return ""
}

export const convertDateFormatToUTCTimeStamp = (date: any) => {
  const momentObj = moment.utc(date, "YYYY-MM-DD HH:mm:ss") // create a Moment.js object in UTC mode from the date string
  const utcTimeStamp = momentObj.valueOf() // get the timestamp in milliseconds
  return utcTimeStamp
}
